/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type EqualizerFragment = {
	id: string;
	description: {
		constraints: {
			configuration: { filterType: { options: Array<Types.EqFilterType> | null } | null } | null;
			gain: { gain: { range: { step: number } } } | null;
		};
	};
	features: {
		configuration: { enabled: boolean; filterType: Types.EqFilterType | null } | null;
		frequency: { frequency: number } | null;
		gain: { gain: number } | null;
		qFactor: { qFactor: number } | null;
	};
};

export type EqualizerFilterChangeFragment = {
	id: string;
	features:
		| { configuration: { enabled: boolean; filterType: Types.EqFilterType | null } | null }
		| { frequency: { frequency: number } | null }
		| { gain: { gain: number } | null }
		| { qFactor: { qFactor: number } | null }
		| {};
};

export type ParametricEqualizerChannelFragment = {
	id: string;
	description: {
		groupName: string;
		constraints: {
			deviceSpecificEqualizerContour: {
				deviceSpecificEqualizerContour: { options: Array<Types.DeviceSpecificEqualizerContour> } | null;
			} | null;
		};
		features: {
			equalizer: { supported: boolean };
			deviceSpecificEqualizerContour: { supported: boolean };
			micOptimization: { supported: boolean };
			channelConfiguration: { supported: boolean };
		};
	};
	features: {
		name: { name: string } | null;
		equalizer: { filters: Array<EqualizerFragment> } | null;
		deviceSpecificEqualizerContour: { deviceSpecificEqualizerContour: Types.DeviceSpecificEqualizerContour } | null;
		micOptimization: { mode: Types.MicOptimizationMode } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
};

export type ParametricEqualizerChannelChangeFragment = {
	id: string;
	features:
		| { channelConfiguration: { enabled: boolean } | null }
		| {
				deviceSpecificEqualizerContour: {
					deviceSpecificEqualizerContour: Types.DeviceSpecificEqualizerContour;
				} | null;
		  }
		| { equalizerContour: { equalizerContour: Types.EqualizerContour } | null }
		| { micOptimization: { mode: Types.MicOptimizationMode } | null }
		| { name: { name: string } | null }
		| {};
};

export type ParametricEqualizerChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type ParametricEqualizerChannelQueryOpResult = { node: ParametricEqualizerChannelFragment | {} };

export type ParametricEqualizerChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type ParametricEqualizerChannelSubscriptionOpResult = {
	nodeChanges: ParametricEqualizerChannelFragment | ParametricEqualizerChannelChangeFragment | {};
};

export type EqualizerFilterQueryVariables = Types.Exact<{
	filterId: Types.Scalars['ID']['input'];
}>;

export type EqualizerFilterQueryOpResult = { node: EqualizerFragment | {} };

export type EqualizerFilterSubscriptionsVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type EqualizerFilterSubscriptionsOpResult = { nodeChanges: EqualizerFilterChangeFragment | {} };

export type EqualizerFilterMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type EqualizerFilterMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export type ResetEqualizerFiltersMutationVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	scope: Types.DeviceResetScope;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ResetEqualizerFiltersMutationOpResult = {
	resetDevice: { error: { code: Types.ErrorCode; message: string } | null } | {};
};

export type ParametricEqualizerChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ParametricEqualizerChannelMutationOpResult = {
	updateNodes: Array<
		| {
				audioChannel: ParametricEqualizerChannelFragment | null;
				error: { code: Types.ErrorCode; message: string } | null;
		  }
		| {}
	>;
};

export const EqualizerFilterChangeFragment = gql`
	fragment EqualizerFilterChangeFragment on EqualizerFilterChange {
		id
		features {
			... on EqualizerFilterGainChange {
				gain {
					gain
				}
			}
			... on EqualizerFilterConfigurationChange {
				configuration {
					enabled
					filterType
				}
			}
			... on EqualizerFilterFrequencyChange {
				frequency {
					frequency
				}
			}
			... on EqualizerFilterQFactorChange {
				qFactor {
					qFactor
				}
			}
		}
	}
`;
export const EqualizerFragment = gql`
	fragment EqualizerFragment on EqualizerFilter {
		id
		description {
			constraints {
				configuration {
					filterType {
						options
					}
				}
				gain {
					gain {
						range {
							step
						}
					}
				}
			}
		}
		features {
			configuration {
				enabled
				filterType
			}
			frequency {
				frequency
			}
			gain {
				gain
			}
			qFactor {
				qFactor
			}
		}
	}
`;
export const ParametricEqualizerChannelFragment = gql`
	fragment ParametricEqualizerChannelFragment on AudioChannel {
		id
		description {
			groupName
			constraints {
				deviceSpecificEqualizerContour {
					deviceSpecificEqualizerContour {
						options
					}
				}
			}
			features {
				equalizer {
					supported
				}
				deviceSpecificEqualizerContour {
					supported
				}
				micOptimization {
					supported
				}
				channelConfiguration {
					supported
				}
			}
		}
		features {
			name {
				name
			}
			equalizer {
				filters {
					...EqualizerFragment
				}
			}
			deviceSpecificEqualizerContour {
				deviceSpecificEqualizerContour
			}
			micOptimization {
				mode
			}
			channelConfiguration {
				enabled
			}
		}
	}
	${EqualizerFragment}
`;
export const ParametricEqualizerChannelChangeFragment = gql`
	fragment ParametricEqualizerChannelChangeFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelEqualizerContourChange {
				equalizerContour {
					equalizerContour
				}
			}
			... on AudioChannelDeviceSpecificEqualizerContourChange {
				deviceSpecificEqualizerContour {
					deviceSpecificEqualizerContour
				}
			}
			... on AudioChannelMicOptimizationChange {
				micOptimization {
					mode
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const ParametricEqualizerChannelQueryDocument = gql`
	query ParametricEqualizerChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...ParametricEqualizerChannelFragment
		}
	}
	${ParametricEqualizerChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class ParametricEqualizerChannelQueryGQL extends Apollo.Query<
	ParametricEqualizerChannelQueryOpResult,
	ParametricEqualizerChannelQueryVariables
> {
	override document = ParametricEqualizerChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ParametricEqualizerChannelSubscriptionDocument = gql`
	subscription ParametricEqualizerChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...ParametricEqualizerChannelFragment
			...ParametricEqualizerChannelChangeFragment
		}
	}
	${ParametricEqualizerChannelFragment}
	${ParametricEqualizerChannelChangeFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class ParametricEqualizerChannelSubscriptionGQL extends Apollo.Subscription<
	ParametricEqualizerChannelSubscriptionOpResult,
	ParametricEqualizerChannelSubscriptionVariables
> {
	override document = ParametricEqualizerChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const EqualizerFilterQueryDocument = gql`
	query EqualizerFilterQuery($filterId: ID!) {
		node(id: $filterId) {
			...EqualizerFragment
		}
	}
	${EqualizerFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class EqualizerFilterQueryGQL extends Apollo.Query<EqualizerFilterQueryOpResult, EqualizerFilterQueryVariables> {
	override document = EqualizerFilterQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const EqualizerFilterSubscriptionsDocument = gql`
	subscription EqualizerFilterSubscriptions($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on EqualizerFilterChange {
				...EqualizerFilterChangeFragment
			}
		}
	}
	${EqualizerFilterChangeFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class EqualizerFilterSubscriptionsGQL extends Apollo.Subscription<
	EqualizerFilterSubscriptionsOpResult,
	EqualizerFilterSubscriptionsVariables
> {
	override document = EqualizerFilterSubscriptionsDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const EqualizerFilterMutationDocument = gql`
	mutation EqualizerFilterMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on EqualizerFilterOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class EqualizerFilterMutationGQL extends Apollo.Mutation<
	EqualizerFilterMutationOpResult,
	EqualizerFilterMutationVariables
> {
	override document = EqualizerFilterMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ResetEqualizerFiltersMutationDocument = gql`
	mutation ResetEqualizerFiltersMutation($id: ID!, $scope: DeviceResetScope!, $injectKeyring: String) {
		resetDevice(id: $id, scope: $scope, keyring: $injectKeyring) {
			... on DeviceOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class ResetEqualizerFiltersMutationGQL extends Apollo.Mutation<
	ResetEqualizerFiltersMutationOpResult,
	ResetEqualizerFiltersMutationVariables
> {
	override document = ResetEqualizerFiltersMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ParametricEqualizerChannelMutationDocument = gql`
	mutation ParametricEqualizerChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				audioChannel {
					...ParametricEqualizerChannelFragment
				}
				error {
					code
					message
				}
			}
		}
	}
	${ParametricEqualizerChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class ParametricEqualizerChannelMutationGQL extends Apollo.Mutation<
	ParametricEqualizerChannelMutationOpResult,
	ParametricEqualizerChannelMutationVariables
> {
	override document = ParametricEqualizerChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
